import { createSlice } from "@reduxjs/toolkit";

const initialCashFlowState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: [],
    cashflowForEdit: undefined,
    lastError: null,
    message: null,
    error: null,
};
export const callTypes = {
    list: "list",
    action: "action"
};

export const cashflowSlice = createSlice({
    name: "cashflows",
    initialState: initialCashFlowState,
    reducers: {
        catchError: (state, action) => {
            state.error = action.payload.error.clientMessage;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            state.message = null;

            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        endCall: (state, action) => {
            state.error = null;
            state.message = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        // getCashFlowById
        cashflowFetched: (state, action) => {
            state.actionsLoading = false;
            state.cashflowForEdit = action.payload.cashflowForEdit;
            state.floorPlans = action.payload.cashflowForEdit.floorPlans;
            state.error = null;

        },
        // getCashFlowChart
        cashflowChartFetched: (state, action) => {

            state.actionsLoading = false;
            state.cashflowChart = action.payload.cashflowChart;
            state.error = null;

        },
        // getCashFlowChart
        cashflowHourlyChartFetched: (state, action) => {
            state.actionsLoading = false;
            state.cashflowChartHour = action.payload.cashflowChartHour;
            state.error = null;

        },
        // getCashFlowChart
        cashflowHourlyZoneChartFetched: (state, action) => {
            state.actionsLoading = false;
            state.cashflowChartHourZone = action.payload.cashflowChartHourZone;
            state.error = null;

        },
        // get list data
        cashflowsFetched: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
            state.cashflowForEdit = undefined;
            state.floorPlans = undefined;
            state.cashflowChart = undefined;
            state.cashflowChartHour = undefined;
            state.cashflowChartHourZone = undefined;
        },
        // createCashFlow
        cashflowCreated: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.message = action.payload.msgResponse;
        },
        // updateCashFlow
        cashflowUpdated: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.message = action.payload.msgResponse;
        },
        // cashflowDeleted
        cashflowDeleted: (state, action) => {
            state.error = null;
            state.message = action.payload.msgResponse;
            state.actionsLoading = false;
        },
        setMessage: (state, action) => {
            state.error = null;
            state.message = action.payload.msgResponse;
        },
        floorPlanDeleted: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.floorPlans = state.floorPlans.filter(item => item.id !== action.payload.id);
        },
        floorPlanUpdated: (state, action) => {
            const { id, floorPlan } = action.payload;
            state.error = null;
            state.actionsLoading = false;
            state.floorPlans = state.floorPlans.map((data) => {

                if (data.id === id) {
                    return floorPlan;
                }

                return data;
            });
        }

    }
});
